import React, { useContext, useEffect, useRef, useState } 
from 'react'
import { 
    Layout,
    Table,
    Col, 
    Row,
    Button,
    // Modal,
    // Checkbox,
    Upload,
    Popconfirm,
    Form,
    // Select,
    Input,
    // DatePicker,
} from 'antd'
import { InboxOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import Navbar from '../../Components/Navbar/Navbar'
import { validateSpaces } from '../../Utils/Common';
// import AddRowTable from '../../Components/Table/AddRowTable';
// const { Search } = Input;
// const { Option } = Select;
const { Item } = Form;
const { TextArea } = Input;

const EditableContext = React.createContext(null);
const EditableRow = ({ index, ...props }) => {
  const [form] = Form.useForm();
  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  );
};
const EditableCell = ({
  title,
  editable,
  children,
  dataIndex,
  record,
  handleSave,
  ...restProps
}) => {
  const [editing, setEditing] = useState(false);
  const inputRef = useRef(null);
  const form = useContext(EditableContext);
  useEffect(() => {
    if (editing) {
      inputRef.current.focus();
    }
  }, [editing]);
  const toggleEdit = () => {
    setEditing(!editing);
    form.setFieldsValue({
      [dataIndex]: record[dataIndex],
    });
  };
  const save = async () => {
    try {
      const values = await form.validateFields();
      toggleEdit();
      handleSave({
        ...record,
        ...values,
      });
    } catch (errInfo) {
    }
  };
  let childNode = children;
  if (editable) {
    childNode = editing ? (
      <Form.Item
        style={{
          margin: 0,
        }}
        name={dataIndex}
        rules={[
          {
            required: true,
            message: `${title} is required.`,
          },
        ]}
      >
        <Input ref={inputRef} onPressEnter={save} onBlur={save} />
      </Form.Item>
    ) : (
      <div
        className="editable-cell-value-wrap"
        style={{
          paddingRight: 24,
        }}
        onClick={toggleEdit}
      >
        {children}
      </div>
    );
  }
  return <td {...restProps}>{childNode}</td>;
};

const AddExhibitors = () => {
    const [form] = Form.useForm();
    const navigate = useNavigate()
    const [dataSource, setDataSource] = useState([
        {
          key: '0',
          name: 'Edward King 0',
          position: 'Software Developer',
        },
        {
          key: '1',
          name: 'Edward King 1',
          position: 'Software Engineer',
        },
      ]);
    // const data = [
    //     {
    //       key: '0',
    //       name: 'Edward Newgate',
    //       position: 'Captain',
    //       email: 'newgate@mail.com',
    //       mobile_number: ''
    //     },
    //     {
    //       key: '1',
    //       name: 'Gol G. Roger',
    //       age: '32',
    //       address: 'London, Park Lane no. 1',
    //     },
    //   ];
      const [count, setCount] = useState(2);
      const handleDelete = (key) => {
        const newData = dataSource.filter((item) => item.key !== key);
        setDataSource(newData);
      };
      const defaultColumns = [
        {
          title: 'Name',
          dataIndex: 'name',
          width: '30%',
          editable: true,
        },
        {
          title: 'Position',
          dataIndex: 'position',
        },
        {
          // title: 'operation',
          // dataIndex: 'operation',
          render: (_, record) =>
            dataSource.length >= 1 ? (
              <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(record.key)}>
                <div className='center'>
                  <Button>
                    Delete
                  </Button>
                </div>
              </Popconfirm>
            ) : null,
        },
      ];
      const handleAdd = () => {
        const newData = {
          key: count,
          name: `Edward King ${count}`,
          age: '32',
          address: `London, Park Lane no. ${count}`,
        };
        setDataSource([...dataSource, newData]);
        setCount(count + 1);
      };
      const handleSave = (row) => {
        const newData = [...dataSource];
        const index = newData.findIndex((item) => row.key === item.key);
        const item = newData[index];
        newData.splice(index, 1, {
          ...item,
          ...row,
        });
        setDataSource(newData);
      };
      const components = {
        body: {
          row: EditableRow,
          cell: EditableCell,
        },
      };
      const columns = defaultColumns.map((col) => {
        if (!col.editable) {
          return col;
        }
        return {
          ...col,
          onCell: (record) => ({
            record,
            editable: col.editable,
            dataIndex: col.dataIndex,
            title: col.title,
            handleSave,
          }),
        };
      });
      const normFile = (e) => {
        if (Array.isArray(e)) {
          return e;
        }
        return e?.fileList;
      };
  return (
    <Layout className='page'>
        <Navbar/>
        <Layout className='content-container overflow-y'>
            <Row>
                <Col span={24} className='header-container p-4'>
                    ADD EXHIBITORS
                </Col>
            </Row>
            <Row>
                <Col span={24} className='p-4'>
                    <Form form={form} layout="vertical">
                        <Row>
                            <Col span={12} className='p-2'>
                              <Item
                                  label="Name"
                                  name="name"
                                  rules={[
                                    { required: true, message: 'Please enter your Name!' },
                                    { validator: validateSpaces }
                                  ]}
                              >
                                  <Input />
                              </Item>
                            </Col>
                            <Col span={12} className='p-2'>
                              <Item
                                  label="Address"
                                  name="address"
                                  rules={[
                                    { required: true, message: 'Please enter your Address!' },
                                    { validator: validateSpaces }
                                  ]}
                              >
                                  <Input />
                              </Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={12} className='p-2'>
                                <Item
                                    label="TIN Number"
                                    name="tin"
                                    rules={[
                                      { required: true, message: 'Please enter your confirm TIN Number!' },
                                      { validator: validateSpaces }
                                    ]}
                                >
                                    <Input />
                                </Item>
                            </Col>
                            <Col span={12} className='p-2'>
                                <Item
                                    label="Email"
                                    name="email"
                                    rules={[
                                      { required: true, message: 'Please enter your confirm Email!' },
                                      { type: 'email', message: 'Please enter a valid email address!' }
                                    ]}
                                >
                                    <Input />
                                </Item>
                            </Col>
                        </Row>
                    
                        <Row>
                            <Col span={12} className='p-2'>
                                <Item
                                    label="Contact Person"
                                    name="contact_person"
                                    rules={[
                                      { required: true, message: 'Please enter your Contact Person!' },
                                      { validator: validateSpaces }
                                    ]}
                                >
                                    <Input />
                                </Item>
                            </Col>
                            <Col span={12} className='p-2'>
                                <Item
                                    label="Contact Number"
                                    name="contact_number"
                                    rules={[
                                      { required: true, message: 'Please enter your Contact Number!' },
                                      { validator: validateSpaces }
                                    ]}
                                >
                                    <TextArea rows={1}/>
                                </Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24} className='p-2'>
                                <Item
                                    label="Business Name"
                                    name="business_name"
                                >
                                    <TextArea rows={6}/>
                                </Item>
                            </Col>
                            <Col span={24} className='p-2'>
                                <Item
                                    label="Nature of Renter"
                                    name="nature"
                                >
                                    <TextArea rows={6}/>
                                </Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24} className='p-2'>
                                Authorized Signatories
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24} className='p-2'>
                                <Table
                                    components={components}
                                    rowClassName={() => 'editable-row'}
                                    bordered
                                    dataSource={dataSource}
                                    columns={columns}
                                />
                                <Button
                                    onClick={handleAdd}
                                    type="primary"
                                    style={{
                                    marginBottom: 16,
                                    }}
                                >
                                    Add a row
                                </Button>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24} className='p-2'>
                                <Form form={form} layout="vertical">
                                    <Form.Item label="Attachment">
                                        <Form.Item name="dragger" valuePropName="fileList" getValueFromEvent={normFile} noStyle>
                                            <Upload.Dragger name="files" action="/upload.do">
                                            <p className="ant-upload-drag-icon">
                                                <InboxOutlined />
                                            </p>
                                            <p className="ant-upload-text">Click or drag file to this area to upload</p>
                                            <p className="ant-upload-hint">Support for a single or bulk upload.</p>
                                            </Upload.Dragger>
                                        </Form.Item>
                                    </Form.Item>
                                </Form>
                            </Col>
                        </Row>
                        <Row className='justify-content-end'>
                            <Col span={2} className='p-2'>
                              <Button
                                // onClick={handleAdd}
                              >
                                Cancel
                              </Button>
                            </Col>
                            <Col span={2} className='p-2'>
                              <Button
                                onClick={() => navigate('/edit-tenant-rate')}
                                type='primary'
                              >
                                Save
                              </Button>
                            </Col>
                        </Row>
                    </Form>
                </Col>
            </Row>
        </Layout>
    </Layout>
  )
}

export default AddExhibitors
